import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const Component = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  padding: 160px 20px 0;

  @media (max-width: 800px) {
    padding: 200px 0 0;
  }
`;

const Content = styled.div`
  max-width: 1172px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  color: #f4b141;

  font-family: Montserrat, serif;
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media (max-width: 1230px) {
    font-size: 46px;
  }

  @media (max-width: 800px) {
    font-size: 32px;
    padding: 0 20px;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 80px;

  @media (max-width: 800px) {
    margin-top: 50px;
    padding: 0 20px;
  }
`;

const Text = styled.div`
  color: #023265;
  font-family: Montserrat, serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 33px */

  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 50%;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Form = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 20px;

  width: 50%;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
`;

const FormInput = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Label = styled.label`
  color: rgba(0, 0, 0, 0.5);
  font-family: Montserrat, serif;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 5px;
  display: block;
`;

const StyledInput = styled.input`
  border: 0;
  border-bottom: solid 2px rgba(2, 50, 101, 0.3);
  border-radius: 0;
  padding: 17px 10px 17px 10px;

  box-shadow: 0 0 0 #0000 !important;
  background-color: transparent;

  font-family: Montserrat, serif;
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);

  outline: none;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
    font-family: Montserrat, serif;
    font-size: 18px;
    font-weight: 500;
  }

  &:focus {
    border-bottom-color: #f4b141;
    background-color: transparent;
  }
`;

const PayButton = styled.button`
  padding: 17px 21px;
  border: none;
  border-radius: 20px;

  background: ${(props) => (props.disabled ? '#e0e0e0' : '#f4b141')};
  color: ${(props) => (props.disabled ? '#9a9a9a' : '#e5e7ea')};

  font-family: Montserrat, serif;
  font-size: 22px;
  font-weight: 600;
  text-transform: uppercase;

  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  white-space: nowrap;

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const PaymentFormContainer = styled.div`
  margin-top: -70px;
  width: 100%;

  form {
    margin-bottom: 20px;
  }

  iframe {
    width: 100%;
    min-height: 600px;
    border: 3px solid #ccc;
    border-radius: 8px;
    padding-top: 65px;
    background: white
  }
`;

const ErrorMessage = styled.div`
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c33;
  font-family: Montserrat, serif;
  font-size: 16px;
`;

const LoadingMessage = styled.div`
  margin-top: 20px;
  color: #023265;
  font-family: Montserrat, serif;
  font-size: 16px;
`;

function NetworkPromotionScreenIframeTranzila(props) {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [paymentFormHtml, setPaymentFormHtml] = useState(null);
  const [error, setError] = useState(null);

  const paymentContainerRef = useRef(null);

  // Щойно HTML з backend вставлено в DOM — одразу сабмітимо платіжну форму
  useEffect(() => {
    if (!paymentFormHtml || !paymentContainerRef.current) {
      return;
    }

    const form = paymentContainerRef.current.querySelector('form');
    if (form) {
      form.submit();
    }
  }, [paymentFormHtml]);

  const handlePayNowClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setPaymentFormHtml(null);

    try {
      const response = await axios.post('https://trade.aplit-soft.com/pt/data-form', {
        phone,
      });

      // Backend повертає готовий HTML з формою й iframe — вставляємо як є
      setPaymentFormHtml(response.data);
    } catch (err) {
      console.error('Error fetching payment form:', err);
      setError(
        err.response?.data?.message || err.message || 'Failed to fetch payment form from server'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Component>
      <Content>
        <Title>Pay Promo Network</Title>
        <Grid>
          {!paymentFormHtml && (
            <Form>
              <FormInput>
                <Label htmlFor="phone">Phone number</Label>
                <StyledInput
                  id="phone"
                  type="tel"
                  placeholder="+972 50 000 0000"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </FormInput>

              <PayButton
                type="button"
                disabled={!phone.trim() || loading}
                onClick={handlePayNowClick}
              >
                {loading ? 'Loading...' : 'Pay Now'}
              </PayButton>
            </Form>
          )}

          {loading && <LoadingMessage>Fetching payment form from server...</LoadingMessage>}

          {error && <ErrorMessage>{error}</ErrorMessage>}

          {paymentFormHtml && (
            <PaymentFormContainer
              ref={paymentContainerRef}
              dangerouslySetInnerHTML={{ __html: paymentFormHtml }}
            />
          )}
        </Grid>
      </Content>
    </Component>
  );
}

export default NetworkPromotionScreenIframeTranzila;
